import { Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  publicID: string;
};

export const TransactionID = ({ publicID }: Props) => {
  const { t } = useResource();

  return (
    <Typography variant="h6" fontSize="1rem" fontWeight={600}>
      {t(Resources.Common.TransactionPaymentCode)}: {publicID}
    </Typography>
  );
};
